import { createReducer, createNamespacer } from "../commons/js/utils/reducer";
import { combineReducers } from "redux";
import { fromPairs as _fromPairs } from "lodash";

const namespacers = {
  addBOM: createNamespacer("ADD_BOM"),
  listComponents: createNamespacer("COMPONENTS_LIST"),
  submitBOM: createNamespacer("SUBMIT_BOM"),
  addMaterial: createNamespacer("ADD_MATERIAL"),
};

const initialState = {
  list: {
    isLoading: false,
    components: [],
    error: "",
    showSelectSupplier: false,
    showEmailPopup: false,
    suppliersList: [],
    groupedComponent: {},
    rejectPackageComponent: {},
    showAddMaterial: false,
    isRejected: false,
    procureFormChange: false,
    showSupplierEmail: false,
    updated: false,
    isRevised: false,
    bomAttachment: "",
    bomFilename: "",
    materialName: "",
    materialId: "",
    uploadType: "",
    drawingsApproved: false,
    bomApproved: false,
    rejected: false,
    bomXls: "",
    shopCheck: false,
  },

  addBOM: {
    BOMNumber: { value: "", error: "", showError: "" },
    bomID: "",
    packageID: "",
    status: "",
    url: "",
    bomNotes: "",
    headerNotes: { value: "", error: "", showError: "" },
    approvalNote: "",
    headerNotesId: "",
    active: false,
    bomCreated: true,
    isLoading: false,
    isPrintLoading: false,
    procureFormChange: false,
    checkSupplier: false,
    purchaseOrder: { id: null, po_number: "" },
    requiredDate:"",
  },

  submitBOM: {
    supplierList: { value: [], error: "", showError: "" },
    subject: { value: "", error: "", showError: "" },
  },

  addMaterial: {
    material: { value: "", error: "", showError: "" },
    fabMaterials: [],
    fieldMaterials: [],
    length: { value: "", error: "", showError: "" },
    size: { value: "", error: "", showError: "" },
    description: { value: "", error: "", showError: "" },
    itemNote: { value: "", error: "", showError: "" },
  },
};

const addBOMReducer = createReducer(initialState.addBOM, {
  [namespacers.addBOM("SET_BOM")]: (state, action) => {
    return {
      ...state,
      BOMNumber: {
        ...state.BOMNumber,
        value: action.payload.value,
        bomCreated: action.payload.bomCreated,
      },
    };
  },

  [namespacers.addBOM("SET_BOM_ID")]: (state, action) => {
    const {
      value,
      notes,
      checkSupplier,
      headerNotes,
      headerNotesId,
      approvalNote,
      poNumber,
      purchaseOrder,
      requiredDate,
    } = action.payload;

    const newState = {
      ...state,
      bomID: value,
      bomNotes: notes,
      checkSupplier,
      headerNotes: {
        ...state.headerNotes,
        value: headerNotes,
      },
      headerNotesId,
      approvalNote,
      requiredDate,
    };

    if (purchaseOrder) {
      newState.purchaseOrder = purchaseOrder;
    }

    return newState;
  },

  [namespacers.addBOM("SET_PACKAGE_ID")]: (state, value) => {
    return {
      ...state,
      packageID: value,
    };
  },

  [namespacers.addBOM("CLEAR_FORM")]: (state, action) => {
    return {
      ...initialState.addBOM,
    };
  },

  [namespacers.addBOM("CLEAR_FORM_CHANGE")]: (state, action) => {
    return {
      ...state,
      procureFormChange: false,
    };
  },

  [namespacers.addBOM("CHECK_FOR_SUPPLIER")]: (state, action) => {
    return {
      ...state,
      checkSupplier: action.payload.value,
    };
  },

  [namespacers.addBOM("SET_STATUS")]: (state, action) => {
    return {
      ...state,
      status: action.payload.status,
      url: action.payload.url,
    };
  },

  [namespacers.addBOM("SET_SUPPLIERS_PDF_URLS")]: (state, action) => {
    return {
      ...state,
      state: action.payload.status,
      supplierUrls: action.payload.suppliers
    };
  },

  [namespacers.addBOM("DISABLE_SUBMIT")]: (state, action) => {
    return {
      ...state,
      active: {
        ...state.active,
        value: action.payload.value,
      },
      bomCreated: action.payload.bomCreated,
    };
  },

  [namespacers.addBOM("SET_FIELD_ERRORS")]: (state, action) => {
    let errors = action.payload.value;

    const loadedFields = _fromPairs(
      Object.entries(errors).map((error) => {
        const [key, value] = error;
        return [
          key,
          {
            ...state[key],
            error: value,
          },
        ];
      })
    );

    return {
      ...state,
      ...loadedFields,
    };
  },

  [namespacers.addBOM("SET_LOADING")]: (state, action) => {
    return {
      ...state,
      isLoading: action.payload.value,
    };
  },

  [namespacers.addBOM("SET_PRINT_LOADING")]: (state, action) => {
    return {
      ...state,
      isPrintLoading: action.payload.value,
    };
  },

  [namespacers.addBOM("ADD_NOTES")]: (state, action) => {
    return {
      ...state,
      bomNotes: action.payload.value,
      procureFormChange: true,
    };
  },

  [namespacers.addBOM("SET_PO_NUMBER")]: (state, action) => {
    return {
      ...state,
      purchaseOrder: {
        ...state.purchaseOrder,

        po_number: action.payload.value,
      },
    };
  },

  [namespacers.addBOM("ADD_HEADER_NOTES")]: (state, action) => {
    return {
      ...state,
      headerNotes: {
        ...state.headerNotes,
        value: action.payload.value,
      },
      procureFormChange: true,
    };
  },

  [namespacers.addBOM("SET_PURCHASE_ORDER")]: (state, action) => {
    return {
      ...state,
      purchaseOrder: action.payload.value || { ...initialState.addBOM.purchaseOrder },
    };
  },
});

const listReducer = createReducer(initialState.list, {
  SET_SHOW_SUPPLIER_EMAIL: (state, action) => {
    return {
      ...state,
      showSupplierEmail: action.payload.value,
    };
  },

  SET_SHOW_SELECT_SUPPLIER: (state, action) => {
    return {
      ...state,
      showSelectSupplier: action.payload.value,
    };
  },

  SET_SHOW_EMAIL_POPUP: (state, action) => {
    return {
      ...state,
      showEmailPopup: action.payload.value,
    };
  },

  SET_MATERIAL: (state, action) => {
    return {
      ...state,
      fabMaterials: action.payload.fabMaterials,
      fieldMaterials: action.payload.fieldMaterials,
    };
  },

  SET_SHOW_ADD_MATERIAL: (state, action) => {
    return {
      ...state,
      showAddMaterial: action.payload.value,
    };
  },

  [namespacers.listComponents("SET_COMPONENTS")]: (state, action) => {
    let grouped = {};

    grouped = { ...state.groupedComponent };

    const groupedComponents = action.payload.value;

    for (const groupName of Object.keys(groupedComponents)) {
      groupedComponents[groupName].map((item) => {
        return Object.keys(item).map((name) => {
          return item[name].map((key) => {
            return (grouped[key.id] = {
              ...grouped[key.id],
              groupName,
              ordered_pipe_length: key.ordered_pipe_length || "",
              quantity: key.quantity,
              alternate_description: key.alternate_description,
              length: key.length,
              cutpiece_max_length: key.cutpiece_max_length,
              number_of_nests: key.number_of_nests,
              hide: key.hide,
              pre_order: key.pre_order,
              asset_number: key.asset_number,
              supplier_id: key.supplier_id,
              ordered_rod_length: key.ordered_rod_length,
              hanger_number_of_nests: key.hanger_number_of_nests,
            });
          });
        });
      });
    }

    return {
      ...state,
      components: action.payload.value,
      pageCount: action.payload.pages,
      groupedComponent: { ...grouped },
    };
  },

  [namespacers.listComponents("SET_BOM_ATTACHMENT")]: (state, action) => {
    return {
      ...state,
      bomAttachment: action.payload.value,
      bomFilename: action.payload.bomFilename,
    };
  },

  [namespacers.listComponents("SET_BOM_XLS")]: (state, action) => {
    return {
      ...state,
      bomXls: action.payload.value,
    };
  },

  [namespacers.listComponents("SET_IS_REVISED")]: (state, action) => {
    return {
      ...state,
      isRevised: action.payload.value,
    };
  },

  [namespacers.listComponents("SET_SHOP_CHECK")]: (state, action) => {
    return {
      ...state,
      shopCheck: action.payload.value,
    };
  },

  [namespacers.listComponents("SET_TYPE")]: (state, action) => {
    return {
      ...state,
      uploadType: action.payload.value,
    };
  },

  [namespacers.listComponents("SET_PACKAGE_MATERIAL_NAME")]: (state, action) => {
    return {
      ...state,
      materialName: action.payload.value,
      materialId: action.payload.id,
      drawingsApproved: action.payload.drawingsApproved,
      bomApproved: action.payload.bomApproved,
      rejected: action.payload.rejected,
    };
  },

  [namespacers.listComponents("SET_LOADING")]: (state, action) => {
    return {
      ...state,
      isLoading: action.payload.value,
    };
  },

  [namespacers.listComponents("UPDATED")]: (state, action) => {
    return {
      ...state,
      updated: true,
    };
  },

  [namespacers.listComponents("UPDATED_FALSE")]: (state, action) => {
    return {
      ...state,
      updated: false,
    };
  },

  [namespacers.listComponents("SET_SUPPLIERS_LIST")]: (state, action) => {
    return {
      ...state,
      suppliersList: action.payload.value,
    };
  },

  [namespacers.listComponents("SET_IS_REJECTED")]: (state, action) => {
    return {
      ...state,
      isRejected: action.value,
    };
  },

  [namespacers.listComponents("CLEAR_FORM_CHANGE")]: (state, action) => {
    return {
      ...state,
      procureFormChange: false,
    };
  },

  [namespacers.listComponents("CLEAR_FORM")]: (state, action) => {
    return {
      ...state,
      groupedComponent: {
        ...initialState.list.groupedComponent,
      },
      rejectPackageComponent: {
        ...initialState.list.rejectPackageComponent,
      },
      procureFormChange: false,
    };
  },

  [namespacers.listComponents("SET_NEST_ERROR")]: (state, action) => {
    let grouped = {};

    grouped = { ...state.groupedComponent };

    grouped[action.payload.id] = {
      ...grouped[action.payload.id],
      error: action.payload.error,
    };

    return {
      ...state,
      groupedComponent: { ...grouped },
    };
  },

  [namespacers.listComponents("SET_QUANTITY")]: (state, action) => {
    let grouped = {};

    grouped = { ...state.groupedComponent };

    const { name, id, value } = action.payload;

    if (name !== "item_notes") {
      if (name === "quantity" || name === "length" || name === "ordered_rod_length")
        grouped[id] = {
          ...grouped[id],
          [action.payload.nestKey]: action.payload.nests,
          [name]: value,
          back_order: value,
        };
      else if (name === "pre_order") {
        grouped[id] = {
          ...grouped[id],
          [name]: value,
          hide: value,
        };
      } else if (name === "hide") {
        value === false
          ? (grouped[id] = {
              ...grouped[id],
              [name]: value,
              pre_order: value,
            })
          : (grouped[id] = {
              ...grouped[id],
              [name]: value,
            });
      } else if (name === "asset_number") {
        grouped[id] = {
          ...grouped[id],
          [name]: value,
        };
      } else {
        grouped[id] = {
          ...grouped[id],
          [name]: value,
        };
      }
    } else {
      grouped[id] = {
        ...grouped[id],

        bom_note_attributes: {
          content: value,
          context: "bom",
        },
      };
    }

    return {
      ...state,
      groupedComponent: { ...grouped },
      procureFormChange: true,
    };
  },
  [namespacers.listComponents("SET_REJECT")]: (state, action) => {
    let grouped = {};

    grouped = { ...state.rejectPackageComponent };

    if (action.payload.value === false) {
      delete grouped[action.payload.id];
    } else {
      grouped[action.payload.id] = {
        ...grouped[action.payload.id],
        [action.payload.name]: action.payload.value,
      };
    }

    return {
      ...state,
      rejectPackageComponent: { ...grouped },
    };
  },
  [namespacers.listComponents("SET_REJECT_COMMENTS")]: (state, action) => {
    let grouped = {};

    grouped = { ...state.rejectPackageComponent };

    if (action.payload.name === "comment") {
      grouped[action.payload.id] = {
        ...grouped[action.payload.id],
        comment_attributes: {
          description: action.payload.value,
          user_id: action.payload.userId,
        },
      };
    }
    return {
      ...state,
      rejectPackageComponent: { ...grouped },
    };
  },
});

const submitBOM = createReducer(initialState.submitBOM, {
  [namespacers.submitBOM("SET_SUBJECT")]: (state, action) => {
    return {
      ...state,
      subject: {
        ...state.subject,
        value: action.payload.value,
      },
    };
  },

  [namespacers.submitBOM("LOAD_DATA")]: (state, action) => {
    const responseMapping = {
      BomNumber: "bom_number",
      packageId: "package_id",
      supplier: "bom_suppliers",
      supplierList: "suppliers"
    };

    const loadedFields = _fromPairs(
      Object.entries(responseMapping).map((entry) => {
        const [key, responseKey] = entry;
        return [
          key,
          {
            ...state[key],
            value: action.payload.value[responseKey] || "",
          },
        ];
      })
    );

    return {
      ...state,
      ...loadedFields,
    };
  },

  [namespacers.submitBOM("SET_FIELD_ERRORS")]: (state, action) => {
    let errors = action.payload.value;

    const loadedFields = _fromPairs(
      Object.entries(errors).map((error) => {
        const [key, value] = error;
        return [
          key,
          {
            ...state[key],
            error: value,
          },
        ];
      })
    );

    return {
      ...state,
      ...loadedFields,
    };
  },

  [namespacers.submitBOM("CLEAR_FORM")]: (state, action) => {
    return {
      ...initialState.submitBOM,
    };
  },
});

const addMaterial = createReducer(initialState.addMaterial, {
  [namespacers.addMaterial("SET_LENGTH")]: (state, action) => {
    return {
      ...state,
      length: {
        ...state.length,
        value: action.payload.value,
      },
    };
  },

  [namespacers.addMaterial("SET_SIZE")]: (state, action) => {
    return {
      ...state,
      size: {
        ...state.size,
        value: action.payload.value,
      },
    };
  },

  [namespacers.addMaterial("SET_DESCRIPTION")]: (state, action) => {
    return {
      ...state,
      description: {
        ...state.description,
        value: action.payload.value,
      },
    };
  },

  [namespacers.addMaterial("SET_MATERIAL_TYPE")]: (state, action) => {
    return {
      ...state,
      material: { value: action.payload.value.value, label: action.payload.value.label },
    };
  },

  [namespacers.addMaterial("SET_ITEM_NOTE")]: (state, action) => {
    return {
      ...state,
      itemNote: {
        ...state.itemNote,
        value: action.payload.value,
      },
    };
  },

  [namespacers.addMaterial("CLEAR_FORM")]: (state, action) => {
    return {
      ...initialState.addMaterial,
    };
  },

  [namespacers.addMaterial("SET_MATERIAL")]: (state, action) => {
    return {
      ...state,
      fabMaterials: action.payload.fabMaterials,
      fieldMaterials: action.payload.fieldMaterials,
    };
  },

  [namespacers.addMaterial("SET_FIELD_ERRORS")]: (state, action) => {
    let errors = action.payload.value;

    const loadedFields = _fromPairs(
      Object.entries(errors).map((error) => {
        const [key, value] = error;
        return [
          key,
          {
            ...state[key],
            error: value,
          },
        ];
      })
    );

    return {
      ...state,
      ...loadedFields,
    };
  },
});

const reducer = combineReducers({
  addBOM: addBOMReducer,
  list: listReducer,
  submitBOM: submitBOM,
  addMaterial: addMaterial,
});

export default reducer;
